"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_19w24cvs0y = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/repositories/SearchForm.js";
  var hash = "d89a34bb5ac182c3474456b5e56b37d1f99f6b47";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/repositories/SearchForm.js",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 34
        },
        end: {
          line: 15,
          column: 79
        }
      },
      "1": {
        start: {
          line: 24,
          column: 28
        },
        end: {
          line: 24,
          column: 50
        }
      },
      "2": {
        start: {
          line: 25,
          column: 28
        },
        end: {
          line: 25,
          column: 50
        }
      },
      "3": {
        start: {
          line: 26,
          column: 44
        },
        end: {
          line: 26,
          column: 59
        }
      },
      "4": {
        start: {
          line: 28,
          column: 29
        },
        end: {
          line: 33,
          column: 3
        }
      },
      "5": {
        start: {
          line: 29,
          column: 25
        },
        end: {
          line: 31,
          column: 6
        }
      },
      "6": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 33
        }
      },
      "7": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "8": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 37,
          column: 42
        }
      },
      "9": {
        start: {
          line: 37,
          column: 18
        },
        end: {
          line: 37,
          column: 40
        }
      },
      "10": {
        start: {
          line: 40,
          column: 18
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "11": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 21
        }
      },
      "12": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 38
        }
      },
      "13": {
        start: {
          line: 45,
          column: 18
        },
        end: {
          line: 48,
          column: 3
        }
      },
      "14": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 21
        }
      },
      "15": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 38
        }
      },
      "16": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 85,
          column: 4
        }
      },
      "17": {
        start: {
          line: 57,
          column: 25
        },
        end: {
          line: 57,
          column: 57
        }
      },
      "18": {
        start: {
          line: 69,
          column: 14
        },
        end: {
          line: 69,
          column: 42
        }
      },
      "19": {
        start: {
          line: 79,
          column: 14
        },
        end: {
          line: 79,
          column: 42
        }
      },
      "20": {
        start: {
          line: 88,
          column: 0
        },
        end: {
          line: 98,
          column: 2
        }
      },
      "21": {
        start: {
          line: 100,
          column: 15
        },
        end: {
          line: 114,
          column: 2
        }
      },
      "22": {
        start: {
          line: 100,
          column: 27
        },
        end: {
          line: 114,
          column: 1
        }
      },
      "23": {
        start: {
          line: 116,
          column: 26
        },
        end: {
          line: 116,
          column: 65
        }
      }
    },
    fnMap: {
      "0": {
        name: "SearchFormComponent",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 28
          }
        },
        loc: {
          start: {
            line: 23,
            column: 3
          },
          end: {
            line: 86,
            column: 1
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 29
          },
          end: {
            line: 28,
            column: 30
          }
        },
        loc: {
          start: {
            line: 28,
            column: 53
          },
          end: {
            line: 33,
            column: 3
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 37,
            column: 12
          },
          end: {
            line: 37,
            column: 13
          }
        },
        loc: {
          start: {
            line: 37,
            column: 18
          },
          end: {
            line: 37,
            column: 40
          }
        },
        line: 37
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 40,
            column: 18
          },
          end: {
            line: 40,
            column: 19
          }
        },
        loc: {
          start: {
            line: 40,
            column: 30
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 40
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 45,
            column: 18
          },
          end: {
            line: 45,
            column: 19
          }
        },
        loc: {
          start: {
            line: 45,
            column: 30
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 45
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 57,
            column: 19
          },
          end: {
            line: 57,
            column: 20
          }
        },
        loc: {
          start: {
            line: 57,
            column: 25
          },
          end: {
            line: 57,
            column: 57
          }
        },
        line: 57
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 68,
            column: 22
          },
          end: {
            line: 68,
            column: 23
          }
        },
        loc: {
          start: {
            line: 68,
            column: 33
          },
          end: {
            line: 70,
            column: 13
          }
        },
        line: 68
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 78,
            column: 22
          },
          end: {
            line: 78,
            column: 23
          }
        },
        loc: {
          start: {
            line: 78,
            column: 33
          },
          end: {
            line: 80,
            column: 13
          }
        },
        line: 78
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 100,
            column: 15
          },
          end: {
            line: 100,
            column: 16
          }
        },
        loc: {
          start: {
            line: 100,
            column: 27
          },
          end: {
            line: 114,
            column: 1
          }
        },
        line: 100
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }, {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }],
        line: 35
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "d89a34bb5ac182c3474456b5e56b37d1f99f6b47"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchForm = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _awesomeDebouncePromise = _interopRequireDefault(require("awesome-debounce-promise"));

var _core2 = require("../../core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var repositorySearchDebounced = (cov_19w24cvs0y.s[0]++, (0, _awesomeDebouncePromise.default)(_core2.repositorySearch, 250));

function SearchFormComponent(_ref) {
  var classes = _ref.classes,
      defaultOwner = _ref.defaultOwner,
      defaultQuery = _ref.defaultQuery,
      onRepositories = _ref.onRepositories,
      config = _ref.config;
  cov_19w24cvs0y.f[0]++;

  var _ref2 = (cov_19w24cvs0y.s[1]++, (0, _react.useState)(defaultOwner)),
      _ref3 = _slicedToArray(_ref2, 2),
      owner = _ref3[0],
      setOwner = _ref3[1];

  var _ref4 = (cov_19w24cvs0y.s[2]++, (0, _react.useState)(defaultQuery)),
      _ref5 = _slicedToArray(_ref4, 2),
      query = _ref5[0],
      setQuery = _ref5[1];

  var _ref6 = (cov_19w24cvs0y.s[3]++, (0, _react.useState)(false)),
      _ref7 = _slicedToArray(_ref6, 2),
      initialSearch = _ref7[0],
      setInitialSearch = _ref7[1];

  cov_19w24cvs0y.s[4]++;

  var updateRepositories = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(owner, query) {
      var repositories;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cov_19w24cvs0y.f[1]++;
              cov_19w24cvs0y.s[5]++;
              _context.next = 4;
              return repositorySearchDebounced({
                owner: owner,
                query: query,
                config: config
              });

            case 4:
              repositories = _context.sent;
              cov_19w24cvs0y.s[6]++;
              onRepositories(repositories);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function updateRepositories(_x, _x2) {
      return _ref8.apply(this, arguments);
    };
  }();

  cov_19w24cvs0y.s[7]++;

  if (!initialSearch) {
    cov_19w24cvs0y.b[0][0]++;
    cov_19w24cvs0y.s[8]++;
    updateRepositories(owner, query).then(function () {
      cov_19w24cvs0y.f[2]++;
      cov_19w24cvs0y.s[9]++;
      return setInitialSearch(true);
    });
  } else {
    cov_19w24cvs0y.b[0][1]++;
  }

  cov_19w24cvs0y.s[10]++;

  var onOwner = function onOwner(_owner) {
    cov_19w24cvs0y.f[3]++;
    cov_19w24cvs0y.s[11]++;
    setOwner(_owner);
    cov_19w24cvs0y.s[12]++;
    updateRepositories(_owner, query);
  };

  cov_19w24cvs0y.s[13]++;

  var onQuery = function onQuery(_query) {
    cov_19w24cvs0y.f[4]++;
    cov_19w24cvs0y.s[14]++;
    setQuery(_query);
    cov_19w24cvs0y.s[15]++;
    updateRepositories(owner, _query);
  };

  cov_19w24cvs0y.s[16]++;
  return _react.default.createElement(_core.ListItem, {
    ContainerComponent: "div",
    className: classes.root
  }, _react.default.createElement(_core.ListItemIcon, {
    className: classes.listItemIcon
  }, _react.default.createElement(_core.IconButton, {
    onClick: function onClick() {
      cov_19w24cvs0y.f[5]++;
      cov_19w24cvs0y.s[17]++;
      return updateRepositories(owner, query);
    }
  }, _react.default.createElement(_icons.Search, null))), _react.default.createElement("form", {
    className: classes.form
  }, _react.default.createElement("div", {
    className: classes.input
  }, _react.default.createElement(_core.TextField, {
    id: "owner",
    label: "Owner",
    type: "text",
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    defaultValue: owner,
    autoComplete: undefined,
    onChange: function onChange(event) {
      cov_19w24cvs0y.f[6]++;
      cov_19w24cvs0y.s[18]++;
      onOwner(event.target.value);
    }
  })), _react.default.createElement("div", {
    className: classes.input
  }, _react.default.createElement(_core.TextField, {
    id: "search",
    label: "Search",
    type: "text",
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    defaultValue: query,
    autoFocus: true,
    autoComplete: undefined,
    onChange: function onChange(event) {
      cov_19w24cvs0y.f[7]++;
      cov_19w24cvs0y.s[19]++;
      onQuery(event.target.value);
    }
  }))));
}

cov_19w24cvs0y.s[20]++;
SearchFormComponent.propTypes = {
  classes: _propTypes.default.object.isRequired,

  /** Prefill the owner search field. */
  defaultOwner: _propTypes.default.string,

  /** Prefill the query search field. */
  defaultQuery: _propTypes.default.string,

  /** Function to propogate the returned repositories data array. */
  onRepositories: _propTypes.default.func.isRequired,

  /** Configuration required if paths are provided as URL. */
  config: _propTypes.default.shape({
    server: _propTypes.default.string.isRequired
  }).isRequired
};
cov_19w24cvs0y.s[21]++;

var styles = function styles(theme) {
  cov_19w24cvs0y.f[8]++;
  cov_19w24cvs0y.s[22]++;
  return {
    root: {
      position: 'sticky',
      borderRadius: theme.shape.borderRadius,
      marginLeft: 0,
      width: '100%'
    },
    listItemIcon: {
      marginRight: '8px'
    },
    form: {
      width: '100%'
    },
    input: {
      width: '40%',
      display: 'inline-block',
      marginRight: '1em'
    }
  };
};

var SearchForm = (cov_19w24cvs0y.s[23]++, (0, _styles.withStyles)(styles)(SearchFormComponent));
exports.SearchForm = SearchForm;